import { formatFirebaseError } from '@strenforcement/domain/formatting';

export function formatError(error) {
  return formatFirebaseError(error);
}
